module.exports = __webpack_public_path__ + "img/jobs.1fd5cb32.svg";